import { render, staticRenderFns } from "./GetLabInfo.vue?vue&type=template&id=0b542eaf&"
import script from "./GetLabInfo.vue?vue&type=script&lang=js&"
export * from "./GetLabInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports